import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Progress
} from "reactstrap";
import { Props } from "./horariosClubesComponentTypes";
import { useHorariosClubes } from "./hooks/useHorariosClubes";
import ConfiguracionCard from "./ConfiguracionCard";
import {
  ModalHorario,
  ModalNuevaConfiguracion,
  ModalEditarMantenimientos,
  ModalEditarClubes,
  ModalConfirmarEliminar
} from "./modals/ModalsIndex";

const HorariosClubesContainer: React.FC<Props> = props => {
  const {
    state,
    updateState,
    toggleModalHorario,
    toggleModalNuevaConfiguracion,
    abrirModalConfirmarEliminar,
    cerrarModalConfirmarEliminar,
    handleDiaClick,
    guardarHorario,
    eliminarConfiguracion,
    getClubsDisponibles,
    seleccionarTodosMantenimientos,
    crearNuevaConfiguracion,
    abrirEditarMantenimientos,
    abrirEditarClubes,
    guardarMantenimientos,
    guardarClubes,
    seleccionarTodosClubes,
    loadingStates,
    isAnyOperationInProgress
  } = useHorariosClubes(props);

  const { configuraciones, mantenimientos, clubes } = props;

  const {
    modalHorario,
    modalNuevaConfiguracion,
    nuevaConfiguracion,
    selectedDia,
    horaInicio,
    horaFin,
    modalEditarMantenimientos,
    modalEditarClubes,
    modalConfirmarEliminar,
    mantenimientosSeleccionados,
    clubesSeleccionados
  } = state;

  const clubsDisponibles = getClubsDisponibles();

  if (loadingStates.searching) {
    return (
      <Container fluid className="p-4">
        <div className="text-center">
          <Progress animated value={100} color="danger" />
          <p>Cargando configuraciones...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="p-4">
      <Row className="mb-4">
        <Col xs="auto">
          <Button
            color="danger"
            onClick={toggleModalNuevaConfiguracion}
            disabled={
              clubsDisponibles.length === 0 || isAnyOperationInProgress()
            }
            style={{
              cursor: isAnyOperationInProgress() ? "not-allowed" : "pointer",
              opacity: isAnyOperationInProgress() ? 0.6 : 1
            }}
          >
            {loadingStates.saving ? <>Creando...</> : "+ Nueva Configuración"}
          </Button>
        </Col>
      </Row>

      {configuraciones.map((config: any) => (
        <ConfiguracionCard
          key={config.configuracionId}
          config={config}
          onEditarMantenimientos={abrirEditarMantenimientos}
          onEditarClubes={abrirEditarClubes}
          onEliminar={abrirModalConfirmarEliminar}
          onDiaClick={handleDiaClick}
          loadingStates={loadingStates}
          isAnyOperationInProgress={isAnyOperationInProgress}
        />
      ))}

      {configuraciones.length === 0 && (
        <Card className="text-center py-5">
          <CardBody style={{ backgroundColor: "#313038", color: "white" }}>
            <i className="fa fa-calendar-times-o fa-3x text-muted mb-3"></i>
            <h4 className="text-muted">No hay configuraciones</h4>
            <p className="text-muted">
              Crea una nueva configuración para comenzar
            </p>
            <Button color="danger" onClick={toggleModalNuevaConfiguracion}>
              Crear Primera Configuración
            </Button>
          </CardBody>
        </Card>
      )}

      {/* Modales */}
      <ModalHorario
        isOpen={modalHorario}
        toggle={toggleModalHorario}
        selectedDia={selectedDia}
        horaInicio={horaInicio}
        horaFin={horaFin}
        onHoraInicioChange={hora => updateState({ horaInicio: hora })}
        onHoraFinChange={hora => updateState({ horaFin: hora })}
        onGuardar={guardarHorario}
        loadingStates={loadingStates}
        isAnyOperationInProgress={isAnyOperationInProgress}
      />

      <ModalNuevaConfiguracion
        isOpen={modalNuevaConfiguracion}
        toggle={toggleModalNuevaConfiguracion}
        mantenimientos={mantenimientos}
        clubsDisponibles={clubsDisponibles}
        mantenimientosSeleccionados={mantenimientosSeleccionados}
        clubesSeleccionados={clubesSeleccionados}
        nuevaConfiguracion={nuevaConfiguracion}
        onMantenimientoChange={ids =>
          updateState({ mantenimientosSeleccionados: ids })
        }
        onClubChange={ids => updateState({ clubesSeleccionados: ids })}
        onHorarioChange={horarios =>
          updateState({
            nuevaConfiguracion: { ...nuevaConfiguracion, horarios }
          })
        }
        onSeleccionarTodosMantenimientos={seleccionarTodosMantenimientos}
        onCrear={crearNuevaConfiguracion}
        onSeleccionarTodosClubes={seleccionarTodosClubes}
        loadingStates={loadingStates}
        isAnyOperationInProgress={isAnyOperationInProgress}
      />

      <ModalEditarMantenimientos
        isOpen={modalEditarMantenimientos}
        toggle={() => updateState({ modalEditarMantenimientos: false })}
        mantenimientos={mantenimientos}
        mantenimientosSeleccionados={mantenimientosSeleccionados}
        onMantenimientoChange={ids =>
          updateState({ mantenimientosSeleccionados: ids })
        }
        onGuardar={guardarMantenimientos}
        loadingStates={loadingStates}
        isAnyOperationInProgress={isAnyOperationInProgress}
        onSeleccionarTodosMantenimientos={seleccionarTodosMantenimientos}
      />

      <ModalEditarClubes
        isOpen={modalEditarClubes}
        toggle={() => updateState({ modalEditarClubes: false })}
        clubes={clubes}
        configuraciones={configuraciones}
        configuracionEditando={state.configuracionEditando}
        clubesSeleccionados={clubesSeleccionados}
        onClubChange={ids => updateState({ clubesSeleccionados: ids })}
        onGuardar={guardarClubes}
        loadingStates={loadingStates}
        isAnyOperationInProgress={isAnyOperationInProgress}
        onSeleccionarTodosClubes={seleccionarTodosClubes}
      />

      <ModalConfirmarEliminar
        isOpen={modalConfirmarEliminar}
        toggle={cerrarModalConfirmarEliminar}
        onConfirmar={eliminarConfiguracion}
        loadingStates={loadingStates}
        isAnyOperationInProgress={isAnyOperationInProgress}
      />
    </Container>
  );
};

export default HorariosClubesContainer;
